// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__eh_xx","content":"styles_content__amIJW","links":"styles_links__2J9vk"};